export let ActionComponent = /*#__PURE__*/function (ActionComponent) {
  ActionComponent["EmailForm"] = "email-form";
  ActionComponent["OverlaySignUpButton"] = "overlay-sign-up-button";
  ActionComponent["SignUpButton"] = "sign-up-button";
  ActionComponent["SocialButtons"] = "social-buttons";
  return ActionComponent;
}({});